import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatIcon } from '@angular/material/icon'
import { DocumentTypeService } from '../../../../../core/services/document/document-type/document-type.service'
import { PersonDocumentService } from '../../../../../core/services/person/person-document/person-document.service'
import {
  CreatePersonDocumentModel,
  EditPersonDocumentModel,
} from '../../../../../core/models/person-document.model'
import { ContractClientService } from '../../../../../core/services/contract/contract-client/contract-client.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'contract-upload-create-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    MatIcon,
    MatIconButton,

  ],
  templateUrl: './contract-upload-edit-form.component.html',
  styleUrl: './contract-upload-edit-form.component.scss',
  providers: [DocumentTypeService, PersonDocumentService],
  standalone: true,
})
export class ContractUploadEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private documentTypeService: DocumentTypeService,
    private personDocumentService: PersonDocumentService,
    private contractService: ContractClientService,
    private dialogRef: MatDialogRef<ContractUploadEditFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  initialValues = {
    description: '',
    fileName: ''
  };

  form: FormGroup = new FormGroup({});
  loading: boolean = false;
  file: File | null = null;

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() idContrato: any = '';
  @Input() personId: number = 0

  listType: any[] = []
  allowedTypes = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
    this.fillForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.resetForm()
      this.fillForm()
    }
  }

  getListType() {
    this.documentTypeService.listDocumentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      file: ['', [Validators.required]],
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    const item = this.data.item
    if (this.data.item) {
      this.initialValues = {
        description: item.descricao || '',
        fileName: item.nomeArquivo || ''
      }
    }

    if (this.data.item) {
      this.form.get('description')?.setValue(this.data.item.descricao || '');
      this.form.get('file')?.setValue(this.data.item.nomeArquivo || '');
      this.file = null; 
    }
  }

  hasChanges(): boolean {
    const currentDescription = this.form.get('description')?.value || '';
    const currentFileName = this.form.get('file')?.value || '';

    // Verifica se a descrição mudou OU se um novo arquivo foi selecionado
    return currentDescription !== this.initialValues.description ||
      currentFileName !== this.initialValues.fileName;
  }

  resetForm() {
    this.form.reset()
    this.file = null
  }



  createFile() {
    this.loading = true;
    const formData = new FormData();
    formData.append('id', this.data.idContrato);
    formData.append('descricao', this.form.get('description')!.value ?? '');
    if (this.file) {
      formData.append('arquivo', this.file);
    }

    this.contractService.uploadContract(formData).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message);
        this.response.emit({ refresh: true, clear: true });
        this.resetForm();
        this.loading = false;
        // console.log(formData)
        this.dialogRef.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false;
        this.snackbar.errorRequest(err);
        // console.log(formData)
      },
      complete: () => {
        this.loading = false;
      },
    });
  }




  editFile() {
    this.loading = true;
    const formData = new FormData();
    formData.append('id', this.data.item.id);
    formData.append('descricao', this.form.get('description')!.value ?? '');
    formData.append('PessoaId', this.data.item.pessoaId);
    formData.append('TipoDocId', this.data.item.tipoDocId);


    if (this.file) {
      formData.append('arquivo', this.file);
    }

    this.personDocumentService.editPersonDocument(formData).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message);
        this.response.emit({ refresh: true, clear: true });
        this.resetForm();
        this.loading = false;
        this.dialogRef.close();
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false;
        this.snackbar.errorRequest(err);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }


  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
    this.file = null
  }

  createModel(edit: boolean = false) {
    if (edit) {
      const model = new EditPersonDocumentModel()
      model.Descricao = this.form.get('description')!.value ?? ''
      model.id = this.editItem.id
      model.PessoaId = this.personId
      model.TipoDocId = this.form.get('typeDocument')!.value ?? ''
      model.Arquivo = this.file

      return model.toFormData()
    } else {
      const model = new CreatePersonDocumentModel()
      model.Descricao = this.form.get('description')!.value ?? ''

      model.Arquivo = this.file

      return model.toFormData()
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.file = input.files[0]
      this.form.get('file')?.setValue(this.file.name)
    }
  }

  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }
}
